import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import { ScheduledJobsList } from '@/features/settings/pages';

export const ScheduledJobsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      <Route
        index
        element={
          <RoleBasedGuard roles={['settings.view']}>
            <ScheduledJobsList />
          </RoleBasedGuard>
        }
      />
    </Route>
  </Routes>
);
